/**
 * Shared SignalR Types
 * Common types and interfaces for all SignalR hub clients
 */
import * as signalR from '@microsoft/signalr';
/**
 * Connection state enum
 */
export var ConnectionState;
(function (ConnectionState) {
    ConnectionState["Disconnected"] = "Disconnected";
    ConnectionState["Connecting"] = "Connecting";
    ConnectionState["Connected"] = "Connected";
    ConnectionState["Reconnecting"] = "Reconnecting";
})(ConnectionState || (ConnectionState = {}));
/**
 * Default reconnection configuration
 */
export const DEFAULT_RECONNECTION_CONFIG = {
    initialDelay: 2000, // 2 seconds
    maxDelay: 30000, // 30 seconds
    multiplier: 2, // Double each time
};
/**
 * Default SignalR client options
 */
export const DEFAULT_SIGNALR_OPTIONS = {
    logLevel: signalR.LogLevel.Warning,
    autoReconnect: true,
    maxReconnectAttempts: Infinity,
    reconnectDelays: [2000, 4000, 8000, 16000, 30000], // Exponential backoff
    connectionTimeout: 30000,
    enableKeepAlive: true,
    keepAliveInterval: 15000,
};
/**
 * Hub invocation error
 */
export class HubInvocationError extends Error {
    constructor(message, methodName, originalError) {
        super(message);
        this.methodName = methodName;
        this.originalError = originalError;
        this.name = 'HubInvocationError';
    }
}
/**
 * Connection error
 */
export class ConnectionError extends Error {
    constructor(message, hubUrl, originalError) {
        super(message);
        this.hubUrl = hubUrl;
        this.originalError = originalError;
        this.name = 'ConnectionError';
    }
}
//# sourceMappingURL=types.js.map